import UsuarioConsultanteHistoricoGrid from "components/Elements/UsuarioConsultanteHistoricoGrid";
import React from "react";
import {
  Button,
  Card,
  Container,
  Row,
  Col
 } from "react-bootstrap";
 import { useNavigate} from 'react-router-dom';
 import { useUsuarioSistema } from '../hooks/useUsuarioSistema';

function ListarUsuariosConsultantesHistorico(Usuario) {
    let navigate = useNavigate();
    let usuario=Usuario.usuarioActual.Usuario;
    const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
  const usuarioActual=usuarioActualSistema?.usuarioSistema;
   
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Listado de usuarios consultantes histórico</Card.Title>
                  <p className="card-category">
                    En esta sección se pueden revisar consultantes que están con su proceso cerrado
                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
              
                  <UsuarioConsultanteHistoricoGrid></UsuarioConsultanteHistoricoGrid>
                  
                </Card.Body>
              </Card>
            </Col>
        </Row>
        
        </Container>
      </>
    );
  
  
}

export default ListarUsuariosConsultantesHistorico;
